
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saintValentinGameInstruction",
      function () {
        return require("private-next-pages/saintValentinGameInstruction.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saintValentinGameInstruction"])
      });
    }
  